module.exports = "<p>\r\n\tsettings works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/settings/settings/settings.component.html
// module id = ../../../../../src/app/packages/menu-items/settings/settings/settings.component.html
// module chunks = main